import AdminAccountRequired from "@/layouts/auth/components/AdminAccountRequired";
import AdminHeader from "@/layouts/navigation/components/AdminHeader";
import AddCarousel from "@/pages/admin/add-carousel";
import AdminPasswordChange from "@/pages/admin/admin-password-change";
import ArtworkRequest from "@/pages/admin/artwork-request";
import ArtworkRequests from "@/pages/admin/artwork-requests";
import CustomizeExistingCarousel from "@/pages/admin/customize-existing-carousel";
import CustomizeSearchType from "@/pages/admin/customize-search-type";
import GalleryRequests from "@/pages/admin/gallery-requests";
import HomeCustomization from "@/pages/admin/home-customization";
import LimitedEditionRequests from "@/pages/admin/limited-editions-requests";
import SearchCustomization from "@/pages/admin/search-customization";
import WelcomeAdmin from "@/pages/admin/welcome-admin";

const AdminRoutes = [
  {
    element: <AdminAccountRequired/>,
    children: [
      {
        element: <AdminHeader/>,
        children: [
          { path: "/admin", element: <WelcomeAdmin/> },
          { path: "/admin/change-password", element: <AdminPasswordChange/> },
          { path: "/admin/gallery-requests", element: <GalleryRequests/> },
          { path: "/admin/artwork-requests", element: <ArtworkRequests/> },
          { path: "/admin/limited-edition-requests", element: <LimitedEditionRequests/> },
          { path: "/admin/artwork-request", element: <ArtworkRequest/> }
        ]
      },
      {
        children: [
          { path: "/admin/customize-home", element: <HomeCustomization /> },
          { path: "/admin/customize-existing-carousel/:id", element: <CustomizeExistingCarousel /> },
          { path: "/admin/add-carousel", element: <AddCarousel /> }
        ]
      },
      {
        children: [
          { path: "/admin/customize-search", element: <SearchCustomization /> },
          { path: "/admin/customize-search-type/:type_id", element: <CustomizeSearchType /> },
        ]
      }
    ]
  }
];

export default AdminRoutes;